import { render, staticRenderFns } from "./EConfiguracoesRegras.vue?vue&type=template&id=300f4e5d"
import script from "./EConfiguracoesRegras.vue?vue&type=script&lang=js"
export * from "./EConfiguracoesRegras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports